import { config } from '@/app/config'

import type { AuthProvider } from './types'

export * from './types'

/**
 * Loads the configured provider on first use, so participant pages never download the
 * authentication client. The local provider exists only in development builds.
 */
export async function loadAuthProvider(): Promise<AuthProvider> {
  if (import.meta.env.DEV && config.authMode === 'local') {
    const { createLocalProvider } = await import('./local')
    return createLocalProvider(config.apiBaseUrl)
  }
  const { createCognitoProvider } = await import('./cognito')
  return createCognitoProvider(config.cognito)
}
